/*
 * Panier : le nom du palier Rapid Bundle (« 12 Cards ») ne reflète pas le nombre réel
 * de cartes quand le client change la quantité (4 boîtes affichaient « 12 Cards »).
 * Une unité = une boîte de 4 cartes : on réécrit l'étiquette en « quantité × 4 Cards ».
 * Affichage uniquement : le prix reste celui calculé par Rapid Bundle.
 */
(() => {
  if (window.cartCardCountInitialized) return;
  window.cartCardCountInitialized = true;

  const CARDS_PER_BOX = 4;
  const LABEL = /^\s*(\d+)\s*Cards?\s*$/i;
  // Panier Horizon (input number) et tiroir Rapid Cart (input texte .rapi-cart-drawer__qty-value)
  const QTY_SELECTOR =
    'input[type="number"], input[name^="updates"], input[name*="quantity" i], .rapi-cart-drawer__qty-value, input[class*="qty" i]';

  const findQuantity = (el) => {
    let node = el.parentElement;
    for (let depth = 0; node && depth < 8; depth += 1, node = node.parentElement) {
      const input = node.querySelector(QTY_SELECTOR);
      const value = input ? parseInt(input.value, 10) : NaN;
      if (value > 0) return value;
    }
    return 0;
  };

  const update = () => {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        LABEL.test(node.nodeValue) && !node.parentElement?.closest('.rapi-bundles, .pdp')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT,
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const quantity = findQuantity(node.parentElement);
      if (!quantity) return;
      const text = `${quantity * CARDS_PER_BOX} Cards`;
      if (node.nodeValue.trim() !== text) node.nodeValue = node.nodeValue.replace(/\d+\s*Cards?/i, text);
    });
    addSingleBoxChips();
  };

  // Rapid Cart n'affiche le badge « N Cards » qu'avec une remise : pour 1 boîte (sans remise),
  // on ajoute le même badge, au même endroit, pour que « 4 Cards » s'affiche aussi.
  const CHIP_ICON =
    '<svg viewBox="0 0 20 20" width="12" height="12" aria-hidden="true" focusable="false"><path fill="currentColor" d="M3 4a1 1 0 0 1 1-1h5.6a1 1 0 0 1 .7.3l6.4 6.4a1 1 0 0 1 0 1.4l-5.6 5.6a1 1 0 0 1-1.4 0L3.3 10.3a1 1 0 0 1-.3-.7V4Zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path></svg>';

  const addSingleBoxChips = () => {
    document.querySelectorAll('.rapi-cart-drawer__item').forEach((item) => {
      const name = item.querySelector('.rapi-cart-drawer__name');
      const body = item.querySelector('.rapi-cart-drawer__item-body');
      const quantity = parseInt(item.querySelector('.rapi-cart-drawer__qty-value')?.value, 10);
      if (!body || !quantity || !/DustMite/i.test(name?.textContent || '')) return;

      let added = item.querySelector('[data-card-count-chip]');
      if (item.querySelector('.rapi-cart-drawer__discount-tags:not([data-card-count-chip])')) {
        added?.remove();
        return;
      }
      if (!added) {
        added = document.createElement('span');
        added.className = 'rapi-cart-drawer__discount-tags';
        added.dataset.cardCountChip = '';
        added.innerHTML = `<span class="rapi-cart-drawer__discount-tag-chip"><span class="rapi-cart-drawer__discount-tag-icon">${CHIP_ICON}</span><span></span></span>`;
        body.appendChild(added);
      }
      const label = added.querySelector('.rapi-cart-drawer__discount-tag-chip > span:last-child');
      const text = `${quantity * CARDS_PER_BOX} Cards`;
      if (label.textContent !== text) label.textContent = text;
    });
  };

  let timer = 0;
  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(update, 60);
  };

  const start = () => {
    update();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('input', schedule, true);
    document.addEventListener('change', schedule, true);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
